var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEliminate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 329,
    height: 424,
    viewBox: "0 0 329 424",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5112_1659",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 365,
    width: 300,
    height: 59
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.6 365.329H14V423.604H313.6V365.329Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5112_1659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.667 418.934C234.835 418.934 292.529 361.222 292.529 290.03C292.529 218.838 234.835 161.125 163.667 161.125C92.4985 161.125 34.8052 218.838 34.8052 290.03C34.8052 361.222 92.4985 418.934 163.667 418.934Z",
    fill: "#FFC289"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 363.248H313.601",
    stroke: "#343239",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262 244H51V238H262V244Z",
    fill: "#343239"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21.4883C2 11.8297 9.19381 4 18.0678 4H108.932C117.806 4 125 11.8297 125 21.4883V224.511C125 234.169 117.806 242 108.932 242H18.0678C9.19381 242 2 234.169 2 224.511V21.4883Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 19.6951C0 8.81792 8.05297 0 17.9869 0H109.013C118.947 0 127 8.81792 127 19.6951V224.306C127 235.183 118.947 244 109.013 244H17.9869C8.05297 244 0 235.183 0 224.306V19.6951ZM17.9869 4.14043C10.1415 4.14043 3.78157 11.1046 3.78157 19.6951V224.306C3.78157 232.896 10.1415 239.859 17.9869 239.859H109.013C116.858 239.859 123.218 232.896 123.218 224.306V19.6951C123.218 11.1046 116.858 4.14043 109.013 4.14043H17.9869Z",
    fill: "#343239"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 19C35 16.7909 37.3598 15 40.2706 15H85.7294C88.6404 15 91 16.7909 91 19C91 21.2092 88.6404 23 85.7296 23H40.2706C37.3598 23 35 21.2092 35 19Z",
    fill: "#343239"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M224.332 244C220.835 244 218 241.093 218 237.504V202.493C218 198.907 220.835 196 224.332 196H322.668C326.165 196 329 198.907 329 202.493V237.504C329 241.093 326.165 244 322.668 244H224.332Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.554 202.333V237.512C222.554 238.455 223.296 239.221 224.207 239.221H322.327C323.24 239.221 323.979 238.455 323.979 237.512V202.333C323.979 201.39 323.24 200.627 322.327 200.627H224.207C223.296 200.627 222.554 201.39 222.554 202.333ZM217.889 237.512C217.889 241.118 220.717 244.039 224.207 244.039H322.327C325.816 244.039 328.644 241.118 328.644 237.512V202.333C328.644 198.73 325.816 195.809 322.327 195.809H224.207C220.717 195.809 217.889 198.73 217.889 202.333V237.512Z",
    fill: "#343239"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M245.528 93.5371V195.806H240.862V93.5371H245.528Z",
    fill: "#343239"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M275.577 93.5371V195.806H270.911V93.5371H275.577Z",
    fill: "#343239"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M305.822 93.5371V195.806H301.156V93.5371H305.822Z",
    fill: "#343239"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M314 181.5C314 187.852 309.299 193 303.5 193C297.701 193 293 187.852 293 181.5C293 175.148 297.701 170 303.5 170C309.299 170 314 175.148 314 181.5Z",
    fill: "#F6F3F3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.5 172.819C299.06 172.819 295.462 176.705 295.462 181.5C295.462 186.295 299.06 190.181 303.5 190.181C307.94 190.181 311.538 186.295 311.538 181.5C311.538 176.705 307.94 172.819 303.5 172.819ZM291 181.5C291 174.044 296.597 168 303.5 168C310.403 168 316 174.044 316 181.5C316 188.956 310.403 195 303.5 195C296.597 195 291 188.956 291 181.5Z",
    fill: "#343239"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M284 181.5C284 187.852 279.299 193 273.5 193C267.701 193 263 187.852 263 181.5C263 175.148 267.701 170 273.5 170C279.299 170 284 175.148 284 181.5Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273 172.819C268.385 172.819 264.64 176.705 264.64 181.5C264.64 186.295 268.385 190.181 273 190.181C277.618 190.181 281.36 186.295 281.36 181.5C281.36 176.705 277.618 172.819 273 172.819ZM260 181.5C260 174.044 265.821 168 273 168C280.182 168 286 174.044 286 181.5C286 188.956 280.182 195 273 195C265.821 195 260 188.956 260 181.5Z",
    fill: "#343239"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M314 158C314 164.075 309.299 169 303.5 169C297.701 169 293 164.075 293 158C293 151.925 297.701 147 303.5 147C309.299 147 314 151.925 314 158Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M303.5 149.819C299.06 149.819 295.462 153.705 295.462 158.5C295.462 163.295 299.06 167.181 303.5 167.181C307.94 167.181 311.538 163.295 311.538 158.5C311.538 153.705 307.94 149.819 303.5 149.819ZM291 158.5C291 151.044 296.597 145 303.5 145C310.403 145 316 151.044 316 158.5C316 165.956 310.403 172 303.5 172C296.597 172 291 165.956 291 158.5Z",
    fill: "#343239"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284 158C284 164.075 279.299 169 273.5 169C267.701 169 263 164.075 263 158C263 151.925 267.701 147 273.5 147C279.299 147 284 151.925 284 158Z",
    fill: "#F6F3F3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273 149.819C268.385 149.819 264.64 153.705 264.64 158.5C264.64 163.295 268.385 167.181 273 167.181C277.618 167.181 281.36 163.295 281.36 158.5C281.36 153.705 277.618 149.819 273 149.819ZM260 158.5C260 151.044 265.821 145 273 145C280.182 145 286 151.044 286 158.5C286 165.956 280.182 172 273 172C265.821 172 260 165.956 260 158.5Z",
    fill: "#343239"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M284 134C284 140.075 279.299 145 273.5 145C267.701 145 263 140.075 263 134C263 127.925 267.701 123 273.5 123C279.299 123 284 127.925 284 134Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273 124.819C268.385 124.819 264.64 128.706 264.64 133.5C264.64 138.294 268.385 142.181 273 142.181C277.618 142.181 281.36 138.294 281.36 133.5C281.36 128.706 277.618 124.819 273 124.819ZM260 133.5C260 126.044 265.821 120 273 120C280.182 120 286 126.044 286 133.5C286 140.956 280.182 147 273 147C265.821 147 260 140.956 260 133.5Z",
    fill: "#343239"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51 113.537C51 105.508 57.3437 99 65.1691 99H235.83C243.656 99 250 105.508 250 113.537V239H51V113.537Z",
    fill: "#F6F3F3"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 113.968C49 104.597 56.37 97 65.4617 97H235.538C244.63 97 252 104.597 252 113.968V242H49V113.968ZM65.4617 101.826C58.9556 101.826 53.6816 107.262 53.6816 113.968V237.174H247.318V113.968C247.318 107.262 242.045 101.826 235.538 101.826H65.4617Z",
    fill: "#343239"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M65 115.904C65 113.748 66.6827 112 68.7581 112H232.242C234.318 112 236 113.748 236 115.904V236H65V115.904Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 116.282C63 112.813 65.7149 110 69.0641 110H231.936C235.285 110 238 112.813 238 116.282V238H63V116.282ZM69.0641 114.807C68.2775 114.807 67.6401 115.467 67.6401 116.282V233.193H233.36V116.282C233.36 115.467 232.721 114.807 231.936 114.807H69.0641Z",
    fill: "#343239"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159 174H89V169H159V174Z",
    fill: "#343239"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159 152H89V147H159V152Z",
    fill: "#343239"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M159 195H89V190H159V195Z",
    fill: "#343239"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M184 147V195.329L194.108 183.368L201.505 200L210.326 196.069L203.012 179.622H219L184 147Z",
    fill: "#F6F3F3"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.456 141.204C184.337 140.814 185.363 140.993 186.068 141.659L221.229 174.946C221.955 175.634 222.197 176.707 221.832 177.648C221.467 178.587 220.576 179.206 219.581 179.206H207.245L213.079 192.529C213.622 193.769 213.073 195.223 211.851 195.775L202.99 199.787C202.405 200.054 201.739 200.07 201.141 199.837C200.543 199.603 200.058 199.136 199.798 198.541L193.935 185.149L186.265 194.362C185.609 195.151 184.542 195.439 183.587 195.084C182.635 194.73 182 193.807 182 192.774V143.459C182 142.481 182.572 141.595 183.456 141.204ZM186.84 149.109V186.061L195.218 175.989L203.234 194.292L207.675 192.281L199.795 174.288H213.433L186.84 149.109Z",
    fill: "#343239"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4136 89.3111H71.5956C78.6306 89.3111 84.3586 83.4291 84.3586 76.141V50.5469C78.2135 53.6457 74.6265 58.1792 71.2342 68.5661C67.4525 80.1007 62.6699 85.6671 56.4136 89.3398V89.3111Z",
    fill: "#1A1A1A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4378 47.4756H56.5803C49.5454 47.4756 43.8174 53.3577 43.8174 60.6457V79.3822C52.6875 77.6319 56.8584 72.9837 61.8912 64.9209C68.6203 54.075 71.5399 51.0335 80.4378 47.4756Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEliminate);
export default __webpack_public_path__ + "static/media/eliminate.9e9bbc11d669c07ae2d8ed37f521be96.svg";
export { ForwardRef as ReactComponent };